import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { changeAddonCardQuantityPerBox, changeAddonCardSelections } from '../../../../../redux/box-builder/box-builder.actions';
import Content from '../content';
import { addonCardItemsSelector, selectedAddonsAmountSelector } from '../../../../../redux/box-builder/box-builder.selectors';
const mapStateToProps = createStructuredSelector({
  selectedProductsAmount: selectedAddonsAmountSelector,
  cardItems: addonCardItemsSelector
});
const mapDispatchToProps = dispatch => ({
  onSelectionClick: ({
    itemId,
    isSelected,
    prefillQuantityPerBox
  }) => {
    dispatch(changeAddonCardSelections({
      productId: itemId,
      isSelected,
      prefillQuantityPerBox
    }));
  },
  onChangeHowManyAddonInEachBox: ({
    quantityPerBox,
    itemId
  }) => {
    dispatch(changeAddonCardQuantityPerBox({
      productId: itemId,
      quantityPerBox
    }));
  },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onQuantityInCart: () => {}
});
export default connect(mapStateToProps, mapDispatchToProps)(Content);